import classNames from 'classnames';
import React from 'react';
import UDFormInput from 'ud-form/components/input';
import UDText from 'ud-ui/components/text';
import TooltipWrapper from './tooltip-wrapper';
import { TooltipPosition, TooltipProps } from './types';

interface LabeledInputProps extends TooltipProps {
  label: string;
  name: string;
  placeholder?: string;
  containerClassName?: string;
  inputContainerClassName?: string;
  alignRight?: boolean;
  flexShrink?: boolean;
}

const LabeledInput: React.FC<LabeledInputProps> = ({
  label,
  name,
  placeholder = '0',
  containerClassName = 'mb-4 flex items-center',
  inputContainerClassName = '',
  alignRight = true,
  flexShrink = false,
  tooltip,
  tooltipProps,
}) => {
  const tooltipPosition = tooltipProps?.position || 'right';

  const containerProps = {
    className: `${inputContainerClassName} flex items-center` + (flexShrink ? ' shrink-0' : '') + (alignRight ? ' ml-auto' : ''),
  };

  const renderTooltip = (position: TooltipPosition) => (
    <TooltipWrapper tooltip={tooltip} tooltipProps={{ ...tooltipProps, position }} position={position} />
  );

  return (
    <div className={containerClassName}>
      <div className="flex min-h-10 w-full items-center justify-between">
        <div className="mr-2 flex items-center" style={{ maxWidth: '70%' }}>
          {tooltipPosition !== 'right' ? (
            <>
              {tooltipPosition === 'left' && renderTooltip('left')}
              <UDText type="subhead" className="text-surfaceRaisinBlack50">
                {label}
              </UDText>
            </>
          ) : (
            <>
              <UDText type="subhead" className="text-surfaceRaisinBlack50">
                {label}
                {renderTooltip('right')}
              </UDText>
            </>
          )}
        </div>
        <div className={classNames(containerProps.className)}>
          {tooltipPosition === 'input-left' && renderTooltip('input-left')}
          <UDFormInput name={name} placeholder={placeholder} className="max-w-[120px]" />
          {tooltipPosition === 'input-right' && renderTooltip('input-right')}
        </div>
      </div>
    </div>
  );
};

export default LabeledInput;
